import { useMutation, MutationFunctionOptions, MutationHookOptions } from "react-apollo"
import { DocumentNode } from "graphql"

import { MutationTuple, ReadyMutation } from "typings/form-mutation"
import { getFormErrors } from "shared/apollo/graphql-error/errorsFromException"

/*
  Note: This is custom wrapper over apollo <useMutation>. It helps handle mutation errors via response itself and format them to form errors. We also sending all mutation results as apollo <useMutation> does.
*/
export const useFormMutation = <TData, TVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>
): MutationTuple<TData, TVariables> => {
  const [executeMutation, mutationResult] = useMutation(mutation, options)

  const mutate = async (mutationOptions?: MutationFunctionOptions<TData, TVariables>) => {
    try {
      const response = await executeMutation(mutationOptions)

      if (!response.data) {
        throw new Error("Unexpected: data is empty, but we are not loading and there is no error.")
      }

      return response as ReadyMutation<TData>
    } catch (e) {
      return { error: getFormErrors(e) }
    }
  }

  return [mutate, mutationResult]
}
